<template>
	<div :class="['message', { 'message-owner': !isAiModel }]">
		<message-date :created-at="createdAt" />
		<p class="message-text" v-html="md.render(text)" />

		<message-controls :text="text" />
		<song-settings
			v-if="songSettings"
			:disabled="true"
			:initial-moods="songSettings.moods"
			:initial-genres="songSettings.genres"
			:initial-vocal="songSettings.vocal"
			:initial-tempo="songSettings.tempo"
		/>
	</div>
</template>

<script setup lang="ts">
import markdownit from 'markdown-it'
import markdownItLinkAttributes from 'markdown-it-link-attributes'
import MessageControls from '@/components/MessageControls.vue'
import MessageDate from '@/components/ui/MessageDate.vue'
import SongSettings, { type SongSettingsValue } from '@/components/ui/SongSettings.vue'

const md = markdownit().use(markdownItLinkAttributes, {
	attrs: {
		target: '_blank',
		rel: 'noopener noreferrer'
	}
})

defineProps({
	id: { type: Number, required: false },
	text: { type: String, required: true },
	isAiModel: { type: Boolean, default: false },
	createdAt: { type: String, default: '' },
	songSettings: { type: Object as () => SongSettingsValue | null, default: null }
})
</script>

<style lang="scss" scoped>
.message {
	font: var(--font-body-small);
	border-radius: var(--radius-lg);
	border-bottom-left-radius: var(--radius-tail);
	background-color: var(--background-answer);
	color: var(--text-primary);
	padding: 12px 16px;
	width: 100%;
	margin-bottom: 8px;
	@if $is-mts {
		opacity: 0.8;
		background: var(--background-answer);
	}
	&-owner {
		background-color: var(--background-secondary);
		border-bottom-left-radius: var(--radius-lg);
		border-bottom-right-radius: var(--radius-tail);
		@if $is-mts {
			opacity: 1;
			background: rgba(242, 243, 247, 0.6);
		}
	}
	&-text {
		margin-bottom: 10px;
		word-break: break-word;
	}
	&-controls {
		@include flex-end;
	}
	&-control {
		cursor: pointer;
		transition: $transition-opacity;
		opacity: 0.5;
		@media (min-width: $screen-mobile) {
			&:hover {
				opacity: 1;
			}
			&:active {
				opacity: 0.1;
			}
		}
		&--active {
			opacity: 1;
		}
		&-success {
			color: var(--text-primary);
		}
	}
	// &-date {
	// 	text-align: right;
	// 	@include font-12-normal;
	// }
	.message-text * {
		margin-bottom: 16px;
	}

	:deep(.song-settings) {
		background: transparent;
		box-shadow: none;
		padding: 8px 0 0;
		pointer-events: none;
	}
}
</style>
